import { render, staticRenderFns } from "./QuestionarioHomeCare.vue?vue&type=template&id=af3b4214&scoped=true"
import script from "./QuestionarioHomeCare.vue?vue&type=script&lang=js"
export * from "./QuestionarioHomeCare.vue?vue&type=script&lang=js"
import style0 from "./QuestionarioHomeCare.vue?vue&type=style&index=0&id=af3b4214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3b4214",
  null
  
)

export default component.exports